/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines the minimum submenu size that switches expanded navigation
 * from inline child rendering to the top-tab treatment.
 */
export const FLYOUT_SUBMENU_ITEM_THRESHOLD = 4;

/**
 * Defines the current-theme top navigation fixed-bar offset from the top of the viewport.
 */
export const TOP_NAVIGATION_OFFSET_HEIGHT = 88;
